"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _layout = require("../layout");

var _propTypes = require("../prop-types");

var _text = require("../text");

var _utils = require("../utils");

var _AvatarImage = _interopRequireDefault(require("./AvatarImage"));

var _AvatarLink = require("./AvatarLink");

var _AvatarName = _interopRequireDefault(require("./AvatarName"));

var _avatarConstants = require("./avatarConstants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Avatar = function Avatar(_ref) {
  var username = _ref.username,
      fullName = _ref.fullName,
      _ref$showFullName = _ref.showFullName,
      showFullName = _ref$showFullName === void 0 ? _avatarConstants.AvatarDefaultProps.showFullName : _ref$showFullName,
      imageAltText = _ref.imageAltText,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _avatarConstants.AvatarDefaultProps.size : _ref$size,
      _ref$showImage = _ref.showImage,
      showImage = _ref$showImage === void 0 ? _avatarConstants.AvatarDefaultProps.showImage : _ref$showImage,
      _ref$showUsername = _ref.showUsername,
      showUsername = _ref$showUsername === void 0 ? _avatarConstants.AvatarDefaultProps.showUsername : _ref$showUsername,
      _ref$isUsernameClicka = _ref.isUsernameClickable,
      isUsernameClickable = _ref$isUsernameClicka === void 0 ? _avatarConstants.AvatarDefaultProps.isUsernameClickable : _ref$isUsernameClicka,
      _ref$newTabHiddenText = _ref.newTabHiddenText,
      newTabHiddenText = _ref$newTabHiddenText === void 0 ? _avatarConstants.AvatarDefaultProps.newTabHiddenText : _ref$newTabHiddenText,
      _ref$colorScheme = _ref.colorScheme,
      colorScheme = _ref$colorScheme === void 0 ? _avatarConstants.AvatarDefaultProps.colorScheme : _ref$colorScheme,
      profileImageUrl = _ref.profileImageUrl,
      padding = _ref.padding,
      margin = _ref.margin,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children,
      _ref$renderLink = _ref.renderLink,
      renderLink = _ref$renderLink === void 0 ? _AvatarLink.defaultRenderLink : _ref$renderLink,
      employeeId = _ref.employeeId,
      personId = _ref.personId;
  var layout = _avatarConstants.layoutConstants[size];
  var textColor = colorScheme === _interfaces.AvatarColorScheme.Inverted ? _avatarConstants.INVERTED_COLOR_SCHEME.textColor : _avatarConstants.DEFAULT_COLOR_SCHEME.textColor;

  var renderedChildren = _react.default.Children.toArray(children).slice(0, layout.maxChildren);

  var screenReaderOnImage = !showUsername && (!showFullName || !fullName);
  var hasName = !!fullName || showUsername;
  var hasChildren = !!renderedChildren.length;
  var isAvatarOnly = !hasName && !hasChildren;
  var imageAriaLabel;

  if (!imageAltText) {
    if (!!fullName) {
      imageAriaLabel = "Employee: ".concat(fullName);
    } else if (!!username) {
      imageAriaLabel = "Alias: ".concat(username);
    }
  } else {
    imageAriaLabel = imageAltText;
  }

  var imageSource = personId ? "".concat(_avatarConstants.BADGE_PHOTO_URL, "?personId=").concat(personId) : employeeId ? "".concat(_avatarConstants.BADGE_PHOTO_URL, "?employeeId=").concat(employeeId) : "".concat(_avatarConstants.BADGE_PHOTO_URL, "?uid=").concat(username);
  return (0, _core.jsx)(_context.StencilConsumer, null, function (_ref2) {
    var selectors = _ref2.selectors;
    return (0, _core.jsx)(_layout.Row, {
      "data-test-component": "Avatar",
      "data-test-id": "Avatar_".concat(username),
      padding: padding,
      margin: margin
    }, showImage && (0, _core.jsx)(_AvatarImage.default, {
      selectors: selectors,
      source: profileImageUrl ? profileImageUrl : imageSource,
      size: layout.imageSize,
      marginRight: isAvatarOnly ? 0 : layout.imageSpacing,
      shouldAnnounceImageAltText: screenReaderOnImage,
      imageAltText: imageAriaLabel
    }), !isAvatarOnly && (0, _core.jsx)(_layout.Col, {
      gridGap: layout.spacing,
      justifyContent: "center"
    }, hasName && (0, _core.jsx)(_AvatarName.default, {
      selectors: selectors,
      fullName: fullName,
      showFullName: showFullName,
      username: username,
      showUsername: showUsername,
      isUsernameClickable: isUsernameClickable,
      newTabHiddenText: newTabHiddenText,
      colorScheme: colorScheme,
      fontSize: layout.nameFontSize,
      fontWeight: layout.nameFontWeight,
      lineHeight: layout.nameLineHeight,
      renderLink: renderLink
    }), renderedChildren.map(function (child, index) {
      return /*#__PURE__*/_react.default.isValidElement(child) && (0, _core.jsx)(_text.Text, {
        lineHeight: layout.lineHeight,
        "data-test-component": "AvatarTextLine",
        fontSize: layout.textFontSize,
        color: textColor,
        key: index
      }, /*#__PURE__*/_react.default.cloneElement(child, {
        lineHeight: layout.lineHeight,
        fontSize: layout.textFontSize
      }));
    })));
  });
};

Avatar.displayName = 'Avatar';
Avatar.defaultProps = _objectSpread({}, _avatarConstants.AvatarDefaultProps);
var AvatarWithDocs = (0, _stencilReactDesc.describe)(Avatar).description('Used to graphically represent Amazonians.');
AvatarWithDocs.propTypes = _objectSpread(_objectSpread(_objectSpread({}, (0, _utils.omit)(_AvatarName.default.describedPropTypes, _AvatarName.default.privateProps)), _avatarConstants.sharedPropTypes), {}, {
  username: _stencilReactDesc.PropTypes.string.description('Username of the displayed employee.').isRequired,
  employeeId: _stencilReactDesc.PropTypes.string.description('Unique employee ID of the displayed employee.'),
  showImage: _stencilReactDesc.PropTypes.bool.description('Indicates whether the image should be displayed.'),
  size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.AvatarSize)).description('Size of the avatar.'),
  padding: (0, _propTypes.cssPadding)().description("Sets the CSS 'padding' property for the Avatar."),
  margin: (0, _propTypes.cssMargin)().description("Sets the CSS 'margin' property for the Avatar."),
  children: _stencilReactDesc.PropTypes.node.description('Additional content to display in the Avatar.'),
  imageAltText: _stencilReactDesc.PropTypes.string.description("Optional 'aria-label' for the avatar image. If not provided attempts to create from fullName, otherwise falls back to username. Is only added if no fullName or username are to be displayed with the avatar image."),
  profileImageUrl: _stencilReactDesc.PropTypes.string.description('Overwrites the default avatar image url.')
});
var _default = AvatarWithDocs;
exports.default = _default;